export default __webpack_public_path__ + "static/media/AvatarProfile.90adf790.png";